export type DeskListKind = 'loading' | 'error' | 'empty' | 'filtered' | 'ready';

export function deskListKind(input: {
  loading: boolean;
  error: boolean;
  sourceCount: number;
  visibleCount: number;
}): DeskListKind {
  if (input.loading) return 'loading';
  if (input.error) return 'error';
  if (input.sourceCount === 0) return 'empty';
  if (input.visibleCount === 0) return 'filtered';
  return 'ready';
}

export function toggleHiddenColumn<ColumnId extends string>(hidden: readonly ColumnId[], columnId: ColumnId): ColumnId[] {
  return hidden.includes(columnId) ? hidden.filter((item) => item !== columnId) : [...hidden, columnId];
}

export function parseHiddenColumns<ColumnId extends string>(raw: string | null, allowed: readonly ColumnId[]): ColumnId[] {
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is ColumnId => typeof item === 'string' && allowed.includes(item as ColumnId));
  } catch {
    return [];
  }
}
